import { render, staticRenderFns } from "./VisitFieldCustomField.vue?vue&type=template&id=36498a05&"
import script from "./VisitFieldCustomField.vue?vue&type=script&lang=js&"
export * from "./VisitFieldCustomField.vue?vue&type=script&lang=js&"
import style0 from "./VisitFieldCustomField.vue?vue&type=style&index=0&id=36498a05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports